// extracted by mini-css-extract-plugin
export default {"marca":"MarcaMaestra_marca__axrE1","simbolo":"MarcaMaestra_simbolo__4XuVs","palavra":"MarcaMaestra_palavra__fg4kS"};